module.exports = __webpack_public_path__ + "static/media/Jumbo Construction Icon.0f4444fb.png";